import React, { useState } from "react";
import { Button, Input, Message } from "../../../BP2Components";
import IntlMessages from "../../../../util/IntlMessages";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";

interface PhotoWidgetSettingsProps {
   value: any;
}

const PhotoSettings: React.FC<PhotoWidgetSettingsProps> = ({ value }) => {
   const [settings, setSettings] = useState({
      ...value
   });
   const intl = useIntl();
   const dispatch = useDispatch();

   const handleChange = (value, name) => {
      setSettings(() => ({ ...settings, [name]: value }));
   };
   const handleSubmit = () => {
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   return (
      <>
         <div className="photo-data-settinngs-wrapper">
            <p className="photo-data-settinngs-label">
               <IntlMessages id="settings.listId" />
            </p>
            <Input
               defaultValue={settings?.listId}
               onChange={(e) => handleChange(e.target.value, "listId")}
               className="photo-data-settinngs-input"
            />
         </div>
         <div className="photo-data-settinngs-wrapper">
            <p className="photo-data-settinngs-label">
               <IntlMessages id="settings.photoDataId" />
            </p>
            <Input
               defaultValue={settings?.dataId}
               onChange={(e) => handleChange(e.target.value, "dataId")}
               className="photo-data-settinngs-input"
            />
         </div>
         <div className="photo-data-settinngs-wrapper">
            <p className="photo-data-settinngs-label">
               <IntlMessages id="settings.photoTechName" />
            </p>
            <Input
               defaultValue={settings?.photoTechName}
               onChange={(e) => handleChange(e.target.value, "photoTechName")}
               className="photo-data-settinngs-input"
            />
         </div>
         <Button
            onClick={handleSubmit}
            buttonType="primary"
            htmlType="submit"
            className="photo-settings-btn"
         >
            <IntlMessages id="global.preview" />
         </Button>
      </>
   );
};

export default PhotoSettings;
